import { ReactNode, useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

/**
 * Prevents touch-move scrolling and rubber-banding on iOS Safari.
 * Scrollable children (overflow-y: auto/scroll with actual overflow)
 * are still allowed to scroll normally.
 */
export const ScrollLock = ({
  children,
  className
}: {
  children: ReactNode;
  className?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const handleTouchMove = (e: TouchEvent) => {
      let target = e.target as HTMLElement | null;
      while (target && target !== el) {
        const style = globalThis.getComputedStyle(target);
        const isScrollable =
          (style.overflowY === "auto" || style.overflowY === "scroll") &&
          target.scrollHeight > target.clientHeight;
        if (isScrollable) {
          return;
        }
        target = target.parentElement;
      }
      e.preventDefault();
    };

    el.addEventListener("touchmove", handleTouchMove, { passive: false });
    return () => {
      el.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  return (
    <div ref={ref} className={cn("overscroll-none touch-none", className)}>
      {children}
    </div>
  );
};
